import { WebEnum, WebProps } from "./web.props";

const webReducers = (
  state: WebProps,
  action: { type: WebEnum; payload: any }
) => {
  switch (action.type) {
    case WebEnum.LOADING:
      return {
        ...state,
        loading: { ...action.payload },
      };
    case WebEnum.OPERATIONS_PER_DAY:
      return { ...state, operationsPerDay: action.payload };
    
    case WebEnum.ARRAY_RANDOM_20_DARK_COLORS:
      return { ...state, arrayRandom20DarkColors: action.payload };

    default:
      return state;
  }
};

export default webReducers;
